import React from "react";
import teamPhoto from "../../assets/images/20th.png";

const MANROPE = { fontFamily: '"Manrope", sans-serif' };

export default function CelebrationStory() {
  return (
    <section id="our-story" className="w-full py-16 md:py-24">
      <div className="mx-auto theme-container">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-[80px]">
          <div data-aos="fade-right">
            <span className="section-title-top-tag" style={MANROPE}>
              20 Years of Technology and Innovation
            </span>
            <h2 className="relative mt-6 inline-block text-34 font-semibold text-main-black md:text-48">
              Our Story So Far
              <span className="celebration-underline-bar" aria-hidden="true" />
            </h2>
            <p className="mt-6 leading-relaxed text-paragraph">
              Back in 2006, a few of us set out to build a product. But along the way <strong>we built so much more</strong> - thriving client businesses, long term partnerships, and <strong>real community impact</strong>. Our clients, partners, and team come together to solve problems using cutting edge technology. And <strong>20 years later</strong>, our culture of new product innovation, and continuous improvement continues to be the force that drives us into the future!
            </p>
          </div>
          <div
            className="aspect-[4/3] w-full overflow-hidden rounded-[20px]"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <img
              src={teamPhoto}
              alt="The Informulate team celebrating 20 years"
              className="h-full w-full object-cover object-[65%_35%] transition-transform duration-500 hover:scale-[1.02]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
